import { useState } from 'react';

import { Button, Modal, RadioButton } from '@components';
import { DueDateOptions, PaymentCollectionComponentType } from '@types';

interface GroupDueDateConsentProps {
  showConsent: boolean;
  setShowConsent: (value: boolean) => void;
  collectionType: PaymentCollectionComponentType;
  handleConsentConfirm: (consent: DueDateOptions) => void;
}

const GroupDueDateConsent = ({
  showConsent,
  setShowConsent,
  collectionType,
  handleConsentConfirm
}: GroupDueDateConsentProps) => {
  const [selectedConsent, setSelectedConsent] = useState<'current' | 'next'>(
    'next'
  );
  const consentType = () => {
    if (collectionType === PaymentCollectionComponentType.MONTHLY)
      return 'month';
    if (collectionType === PaymentCollectionComponentType.WEEKLY) return 'week';
    return '';
  };

  return (
    <Modal
      isOpen={showConsent}
      onCancel={() => setShowConsent(false)}
      isClickOutsideRequired={false}
    >
      <div className="flex min-w-90 max-w-90 flex-col gap-4 p-6">
        <div>
          {`The payment link for the current ${consentType()} has already been sent. Select ‘Next ${consentType()}’ to prevent any duplication of payment.`}
        </div>
        <div className="text-grey">
          {`Choose a ${consentType()} to apply the change.`}
        </div>
        <div className="flex gap-6">
          <RadioButton
            isSelected={selectedConsent === 'next'}
            label={`Next ${consentType()}`}
            value="next"
            onChange={(e) =>
              setSelectedConsent(e.target.value as DueDateOptions)
            }
          />
          <RadioButton
            isSelected={selectedConsent === 'current'}
            label={`Current ${consentType()}`}
            value="current"
            onChange={(e) =>
              setSelectedConsent(e.target.value as DueDateOptions)
            }
          />
        </div>
        <div className="mt-2 flex w-full justify-end">
          <Button
            label="Confirm"
            variant="transparent"
            handleClick={() => handleConsentConfirm(selectedConsent)}
            className="w-fit"
          />
        </div>
      </div>
    </Modal>
  );
};

export default GroupDueDateConsent;
